import { Injectable } from "@angular/core";
import { Service } from "src/app/core/jsonapi/service";
import { Mediator } from "../_types/mediator";

@Injectable({
    providedIn: 'root',
})
export class MediatorsService extends Service<Mediator> {
    public override type = 'mediators';
    public override url = 'attendance/mediators';
}
